import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  card: {
    boxShadow: 'none',
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 12,
    height: '100%'
  },
  cardContent: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 16
    },
    [theme.breakpoints.down('md')]: {
      padding: '16px 20px !important'
    }
  }
}))
